export default {
  methods: {
    restorePreviousMapState() {
      this.$root.$emit('restoreMapState', restoredMap => {
        if (!restoredMap) return;
        this.map = restoredMap;
      });
    },
  },
  created() {
    this.$root.$off('restorePreviousMapState');
    this.$root.$on('restorePreviousMapState', this.restorePreviousMapState);
  },
};
